import { useContext, useEffect, useState } from 'react';

import { ReactComponent as XIcon } from '../../../assets/icons/XIcon.svg';
import Context from '../../../store/context';

import classes from './Modal.module.scss';

const Modal = () => {
  const {
    modal: { content, visible, hideModal, isCloseVisible }
  } = useContext(Context);

  const [showModal, setShowModal] = useState(visible);

  useEffect(() => {
    setShowModal(visible);
  }, [visible]);

  const containerClasses = [classes.container];
  if (visible) {
    containerClasses.push(classes.visible);
  }

  const modalClasses = [classes.modal];
  if (showModal) {
    modalClasses.push(classes['modal-visible']);
  }

  const closeHandler = (e) => {
    setShowModal(false);
    setTimeout(() => hideModal(), 250);
  };

  const stopProppagationForModal = (e) => {
    e.stopPropagation();
  }

  return (
    <div onClick={closeHandler} className={containerClasses.join(' ')}>
      <div onClick={stopProppagationForModal} className={modalClasses.join(' ')}>
        {isCloseVisible && (
          <div className={`pointer ${classes.close}`} onClick={closeHandler}>
            <span>Cerrar</span>
            <XIcon className={classes.icon} />
          </div>
        )}
        {content}
      </div>
    </div>
  );
};

export default Modal;
